<template>
  <div class="role-form" ref="roleForm" :class="valid">
    <v-card>
      <v-card-title>
        <h3 class="capitalize">{{ action }} Role</h3>
      </v-card-title>

      <v-card-text>
        <v-form>
          <label>Name</label>
          <v-text-field
            outline
            v-model="role.name"
            :rules="[(v) => !!v || 'name is required']"
          >
          </v-text-field>
          <label>Description</label>
          <v-text-field
            outline
            v-model="role.description"
            :rules="[(v) => !!v || 'description is required']"
          >
          </v-text-field>
          <label>Permissions</label>
          <div
            class="permission-group"
            v-for="(permission, key) in permissions"
            :key="key"
          >
            <label class="capitalize layout align-center">
              <input
                style="width: 20px; height: 20px"
                type="checkbox"
                v-if="role.permissions && !role.permissions['*']"
                :checked="
                  role.permissions[key] &&
                  role.permissions[key].length === permissions[key].length
                "
                class="w-6 h-6 me-2"
                @change="selectAll($event, key)"
              />
              <span class="px-2">{{ key }}</span> {{ role.permissions[key] }}
            </label>
            <v-layout justify-space-between align-center>
              <template v-if="role.permissions && role.permissions['*']">
                <div
                  class="layout align-center mb-3"
                  v-for="act in permission"
                  :key="act"
                >
                  <v-icon>mdi-checkbox-marked</v-icon>
                  <span class="px-1 capitalize">{{ act }}</span>
                </div>
              </template>
              <template v-else>
                <v-checkbox
                  v-for="act in permission"
                  :key="act"
                  v-model="role.permissions[key]"
                  :label="act"
                  :value="act"
                />
              </template>
            </v-layout>
          </div>

          <v-alert :value="error" color="error" icon="warning" outline>
            {{ error }}
          </v-alert>
        </v-form>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-btn
          color="primary"
          arge
          round
          @click="addRole"
          v-if="action === 'add'"
          block
        >
          Add
        </v-btn>
        <v-btn
          color="primary"
          arge
          round
          @click="editRole"
          v-if="action === 'edit'"
          block
        >
          Update
        </v-btn>
        <v-btn
          color="primary"
          arge
          round
          flat
          @click="$emit('closeDialog')"
          block
        >
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import _ from "lodash";
export default {
  name: "addOrEdit",
  props: {
    data: {
      type: Object,
      default: () => {
        return {};
      },
    },
    action: {
      type: String,
      default: () => {
        return "add";
      },
    },
  },
  data() {
    return {
      valid: false,
      role: {
        name: "",
        description: "",
        permissions: {},
      },
      error: "",
    };
  },
  created() {},
  mounted() {
    this.$store.dispatch("fetchPermissions");
    setTimeout(() => {
      this.preparePermissions(this.role);
    }, 2000);
  },
  computed: {
    permissions() {
      return this.$store.state.user.permissions || {};
    },
  },
  methods: {
    preparePermissions(role) {
      if (!role.permissions) {
        role.permissions = {};
      }
      for (let key in this.permissions) {
        if (!role.permissions[key]) {
          this.$set(role.permissions, key, []);
        } else if (!Array.isArray(role.permissions[key])) {
          this.$set(role.permissions, key, [role.permissions[key]]);
        }
      }
    },
    addRole() {
      this.error = "";
      this.$http
        .post("/roles", this.role)
        .then((response) => {
          this.$emit("created", response.data);
          this.$store.dispatch("fetchRoles", true);
          this.$emit("close");
        })
        .catch((error) => {
          this.error = error;
        });
    },
    editRole() {
      this.error = "";
      this.$http
        .put(`/roles/${this.role.id}`, this.role)
        .then((response) => {
          this.$emit("updated", response.data);
          this.$store.dispatch("fetchRoles", true);
          this.$emit("close");
        })
        .catch((error) => {
          this.error = error;
        });
    },
    selectAll(e, module) {
      // console.log(e.target.checked, module)
      let checked = e.target.checked;

      if (this.permissions[module]) {
        this.permissions[module].forEach((permission) => {
          if (!this.role.permissions[module]) {
            this.role.permissions[module] = [];
          }
          if (checked) {
            if (!this.role.permissions[module].includes(permission)) {
              this.role.permissions[module].push(permission);
            }
          } else {
            let index = this.role.permissions[module].indexOf(permission);
            if (index > -1) {
              this.role.permissions[module].splice(index, 1);
            }
          }
        });
      }
    },
  },
  watch: {
    data() {
      this.error = "";
      this.role = _.cloneDeep(this.data);
      this.preparePermissions(this.role);
    },
  },
};
</script>

<style lang="scss" scoped>
.permission-group {
  border: 1px solid #ccc;
  margin-bottom: 10px;
  border-radius: 8px;
  padding: 10px 16px 0;
  ::v-deep .v-input__slot {
    padding-left: 0 !important;
    margin: 0 -2px !important;
  }
}
</style>
